module.exports = __webpack_public_path__ + "static/media/uniswap_uni.aa181653.png";